import { gsap } from 'gsap';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

const SELECTOR = {
  HTML: document.documentElement,
  TRIGGER: document.querySelector('[data-menu-btn]'),
  NAV: document.querySelector('[data-nav]'),
  NAV_BODY: document.querySelector('[data-nav-body]'),
  CLOSE: [...document.querySelectorAll('[data-nav-close]')],
  TARGETS: [...document.querySelectorAll('[data-nav-observer]')],
}

const CLASSES = {
  OPENED: `is-nav-opened`,
  LOCKED: 'is-locked',
  LOCATED: 'is-located'
}

export default class Nav {
  constructor() {
    if(!SELECTOR.NAV || !SELECTOR.TRIGGER) return;

    const options = {
      rootMargin: '-50% 0px',
    };
    
    const observer = new IntersectionObserver(this.callback, options);
    
    SELECTOR.TARGETS.forEach(target => {
      observer.observe(target);
    });
    
    SELECTOR.TRIGGER.addEventListener('click', () => {
      this.showMenu()
    });

    SELECTOR.CLOSE.forEach(_clickedClose => {
      _clickedClose.addEventListener('click', () => {
        this.hideMenu();
      });
    })

    const mediaQuery = window.matchMedia('(min-width: 769px)');

    window.addEventListener('resize', () => {
      if (mediaQuery.matches) {
        this.hideMenu();

      } 
      
    });
  }

  showMenu () {
    SELECTOR.HTML.classList.add(CLASSES.OPENED);
    disableBodyScroll(SELECTOR.NAV_BODY);

    gsap.fromTo(
      SELECTOR.NAV, {
        opacity: 0,
        xPercent: 100,
      }, {
        opacity: 1,
        xPercent: 0,
        duration: 0.5,
        ease: 'power2.out',
      }
    )
  }

  hideMenu () {
    SELECTOR.HTML.classList.remove(CLASSES.OPENED);
    clearAllBodyScrollLocks()

    gsap.fromTo(
      SELECTOR.NAV, {
        opacity: 1,
        xPercent: 0,
      }, {
        opacity: 0,
        xPercent: 100,
        duration: 0.5,
        ease: 'power2.inOut',
      }
    )
  }

  callback(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const currentLocatedIndex = document.querySelector(`[data-nav-list] .${ CLASSES.LOCATED }` );

        if (currentLocatedIndex !== null) {
          currentLocatedIndex.classList.remove(CLASSES.LOCATED);
        }

        const newLocatedIndex = document.querySelector(`a[href='#${ entry.target.id }']`);
        newLocatedIndex.classList.add(CLASSES.LOCATED);
      }
    });
  }

}